module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHVJREFUeNpiYBgFo4BSwAhjlJaW/idFY3d3NyMx6phGw3j4xwEjpQYAfb4fSDlAuQeAPnOkqw9YiI0DYsN86MQB0MfzgVQCDukFQB8nghjM5Fpw7NixjdbW1gpApgEuwymyAIclKIZTDYCCCxpko2AQAoAAAwA4CCdfTwQ5dgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/detail-download.png
// module id = 610
// module chunks = 0